'use strict';

import BaseCollection from './Base.js';
import Model from 'models/Company.js';
import escapeStringRegex from 'escape-string-regexp';

let Collection;

module.exports = Collection = BaseCollection.extend(
/** @lends module:collections.Companies */
{
    /**
     * Companies can be searched by companyName and email
     * @type {Array<String>}
     * @protected
     */
    searchableAttributes: [
        'companyName', 'contactName', 'contactEmail', 'contactPhone', 'username'
    ],

    /**
     * This is specific to company collections. Searchable attributes of
     * mpp admins
     * @type {Array<String>}
     * @protected
     */
    mppSearchableAttributes: [
        'email', 'name'
    ],

    /**
     * Search term of mpp admins
     */
    mppSearchTerm: '',

    /**
     * @constructs
     * @augments module:collections.BaseCollection
     * @param {Array<module:models.Company>=} models
     * @param {module:collections.BaseCollection~initOptions=} options
     */
    initialize(models, options) {
        this.model = Model;
        if (options && options.mppSearchTerm) {
            this.mppSearchTerm = options.mppSearchTerm;

        }
        return BaseCollection.prototype.initialize.apply(this, arguments);
    },

    /**
     * A more complex comparator. Companies can be sorted by some attributes
     * with date values and by the contactPhone in the primary location's
     * address model, for those cases when need to prep the value first.
     *
     * @instance
     * @param {module:models.Company} a
     * @param {module:models.Company} b
     * @returns {Number} The number to sort by
     */
    comparator(a, b) {
        if (this.getSort().key === 'createdAt') {
            return BaseCollection.prototype.valueComparator.apply(this, [
                a.createdAt.valueOf(),
                b.createdAt.valueOf()
            ]);
        }

        if (this.getSort().key === 'contactPhone') {
            let phones = [];

            _([a, b]).each(model => {
                try {
                    phones.push(
                        model.get('location').get('address').get('contactPhone')
                    );
                } catch (e) { phones.push(''); }
            });

            return BaseCollection.prototype.valueComparator.apply(this, phones);
        }

        if (this.getSort().key === 'lastActiveTime') {
            return BaseCollection.prototype.valueComparator.apply(this, [
                (a.get('lastActiveTime') || '').valueOf(),
                (b.get('lastActiveTime') || '').valueOf()
            ]);
        }

        return BaseCollection.prototype.comparator.apply(this, arguments);
    },

    /*
     * @instance
     * @returns {String}
     */
    getMppSearchTerm() {
        return this.mppSearchTerm || '';
    },

    postProcessQuery(query) {
        const matches = this.getMppSearchTerm().match(/\S+/g);
        if (!matches) {
            return query;
        }

        const term = '(' + matches.map(
            unescaped => escapeStringRegex(unescaped)
        ).join('|') + ')';

        query._where || (query._where = {});
        query._where.mppAdmin = {$inQuery: {
            className: '_User',
            where: {
                $or: this.mppSearchableAttributes.map(attr => {
                    const r = {};
                    r[attr] = {$regex: term, $options: 'i'};
                    return r;
                })
            }
        }};

        return query;
    }
});



// WEBPACK FOOTER //
// ./app/collections/Companies.js